export default {
  addSample: 'Dodaj próbkę',
  createOneTimePart: 'Utwórz część jednorazową',
  sample: {
    defaultDisplayName: 'Próbka',
  },
  tableTest: {
    defaultDisplayName: 'Tabela',
  },
  chartTest: {
    defaultDisplayName: 'Wykres',
  },
  imageTest: {
    defaultDisplayName: 'Obraz',
  },
  fileTest: {
    defaultDisplayName: 'Plik',
  },
};
